import { absolutePath } from "./absolutePath";

export const emailHub = {
  onboarding: {
    check: () => absolutePath("email_hub/onboarding"),
  },
};
